export const POEM_QUESTIONS = {
  questions: [
    { key: 'coceira', name: 'Durante a ultima semana, em quantos dias sua pele coçou por causa de sua dermatite?' },
    {
      key: 'sono',
      name: 'Durante a ultima semana, em quantas noites seu sono foi prejudicado por causa de sua dermatite?',
    },
    {
      key: 'sangramento',
      name: 'Durante a ultima semana, em quantos dias sua pele sangrou por causa de sua dermatite?',
    },
    {
      key: 'vazamento',
      name: 'Durante a ultima semana, em quantos dias sua pele vazou ou soltou líquido claro por causa de sua dermatite?',
    },
    {
      key: 'rachaduras',
      name: 'Durante a ultima semana, em quantos dias sua pele apresentou rachaduras por causa de sua dermatite?',
    },
    {
      key: 'descamacao',
      name: 'Durante a ultima semana, em quantos dias sua pele descamou por causa de sua dermatite?',
    },
    {
      key: 'secura',
      name: 'Durante a ultima semana, em quantos dias você sentiu sua pele seca ou áspera por causa de sua dermatite?',
    },
  ],
  options: [
    {
      key: 'nenhum',
      label: 'Nenhum dia',
      value: 0,
    },
    {
      key: 'umadois',
      label: '1 a 2 dias',
      value: 1,
    },
    {
      key: 'tresaquatro',
      label: '3 a 4 dias',
      value: 2,
    },
    {
      key: 'cincoaseis',
      label: '5 a 6 dias',
      value: 3,
    },
    {
      key: 'todos',
      label: 'Todos os dias',
      value: 4,
    },
  ],
}
